const img = require('./HintStandart.jpg'); export default img;